// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ro-z","image":"So-z","lazyLoadPicture":"To-z","lazyLoadSpinner":"Uo-z","lazyLoadSpin":"Vo-z","lazyLoadImage":"Wo-z","hasStyledAspectRatio":"Xo-z"};